<div class="row"  *ngFor="let item of roleFeatures; let item_index = index">
  <div class="col-md-12">
    <h1 class="header-tb">{{item.module_name}} Module</h1>
    <div class="table-container tb-checkbox">
      <table mat-table matSort matSortDisableClear [dataSource]="item.features">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="pl"></th>
          <td mat-cell *matCellDef="let element" [matTooltipPosition]="'after'"
            [matTooltip]="element?.name.length > 35 ? element?.name : ''" class="text-truncate pl">
            <b>{{element?.name}}</b></td>
        </ng-container>
        <ng-container matColumnDef="create">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px">{{'Create' | translate}}</th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.create" color="primary" *ngIf="element.create"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="retrieve">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px">{{'Retrieve' | translate}}</th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.retrieve" color="primary" *ngIf="element.retrieve"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="update">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px">{{'Update' | translate}}</th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.update" color="primary" *ngIf="element.update"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px">{{'Delete' | translate}}</th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.delete" color="primary" *ngIf="element.delete"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="validate">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px"> {{'Validate' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.validate" color="primary" *ngIf="element.validate"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="override">
          <th mat-header-cell *matHeaderCellDef class="text-center" width="100px"> {{'Override' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <mat-checkbox class="no-pointer" [checked]="element.override" color="primary" *ngIf="element.override"></mat-checkbox>
          </td>
        </ng-container>

      </table>
      <div *ngIf="!roleFeatures?.length" class="p-2 text-center">{{ 'No data' | translate}}</div>
    </div>
  </div>
</div>
